import { useTranslation } from "@next-platform/client-common-core";
import { Filter, type FilterV2ActionHandler, type IFilterItem } from "@next-platform/client-common-spicy-ui";
import React from "react";

import Trans from "@/components/Trans/Trans";

import FilterSectionV2 from "../FiltersV2/FilterSectionV2";

type FilterBoxFeatureSectionProps = {
  actionHandler: FilterV2ActionHandler;
  isFiltersV2: boolean;
  items: IFilterItem[];
};

const FilterBoxFeatureSection = ({ actionHandler, isFiltersV2, items }: FilterBoxFeatureSectionProps) => {
  const { t } = useTranslation();

  if (isFiltersV2) {
    const featuresTitle = t("chatbotFilters:filterByFeatures.title");
    return <FilterSectionV2 actionHandler={actionHandler} data-testid="FeaturesCapabilityGate" hasExclude items={items} title={featuresTitle} />;
  }

  return (
    <Filter data={items} actionHandler={actionHandler} dataTestId="FeaturesCapabilityGate">
      <Filter.Header>
        <Filter.Title>
          <Trans i18nKey="chatbotFilters:filterByFeatures.title" />
        </Filter.Title>
        <Filter.Reset alwaysShow>
          <Trans i18nKey="common:reset" />
        </Filter.Reset>
      </Filter.Header>
      <Filter.Body hasExclude />
    </Filter>
  );
};

export default React.memo(FilterBoxFeatureSection);
